import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';
import { TrackingLink } from 'lib/app/tracking-link';
import { CdnImagePath } from 'lib/cdn-image-path';
import LocaleContext from 'lib/locale-context';

import { onClickAboutCTA } from 'containers/events';

import PageSectionCta from 'components/page/sections/page-section-cta';

export const ComplimentsBlockOneContainer: FunctionComponent = () => {
  const lang = React.useContext(LocaleContext);

  const imagePath = `${CdnImagePath}/bumble/l-assets/${lang}/features/Compliments-HowComplimentFeaturesWork.jpg`;

  const props = {
    imagePosition: 'left',
    imageSrc: imagePath,
    imageObjectPosition: '33% 31%',
    imageAlt: '',
    title: features.compliments.lxComplimentsOneBlockTitle,
    text: features.compliments.lxComplimentsOneBlockBodyText,
    actionText: features.compliments.lxFeaturesDownloadBumbleCta,
    actionUrl: TrackingLink.APPSFLYER_LINK,
  };

  return (
    <PageSectionCta
      title={props.title}
      /**
       * Fix language based code
       */
      // titleLang={'en'}
      text={props.text}
      action={{
        text: props.actionText,
        href: props.actionUrl,
        onClick: onClickAboutCTA,
      }}
      image={{
        src: props.imageSrc,
        objectPosition: props.imageObjectPosition,
        inlinePosition: 'start',
      }}
      color="yellow"
    />
  );
};
